/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
// import { format } from 'libphonenumber-js';
import { format } from 'libphonenumber-js';
import Vue from 'vue';
import * as mTypes from '../../mutation-types';

const state = {
  landlord: {},
  error: null,
  account_creation: false,
};

const getters = {
  landlord: state => state.landlord,
  selectedLandlordId: state => (state.landlord ? state.landlord.id : null),
  error: state => state.error,
  account_creation: state => state.account_creation,
};

const actions = {
  fetch({ commit }, payload) {
    const path = `${payload.isSuperAdmin ? 'superadmin' : 'landlords'}/${payload.user.data.id}`;
    return Vue.http.get(`${process.env.BACKEND_API_URL}api/${path}/landlords/${payload.id}`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
        return response;
      }).catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
  saveLandlord({ commit }, payload) {
    const path = `superadmin/${payload.user.data.id}`;
    let request;
    if (payload.landlord.id) {
      request = Vue.http.put(`${process.env.BACKEND_API_URL}api/${path}/landlords/${payload.landlord.id}`, payload.landlord);
    } else {
      request = Vue.http.post(`${process.env.BACKEND_API_URL}api/${path}/landlords/`, payload.landlord);
    }
    return request
      .then((response) => {
        commit(mTypes.DATA_STORED, response);
      })
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
  activateLandlordAccount({ commit }, payload) {
    return Vue.http.get(`${process.env.BACKEND_API_URL}api/account/${payload.user}`)
      .then((response) => {
        commit(mTypes.UPDATE_USER, response.data.data);
      })
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
  createLandlordAccount({ commit }, payload) {
    return Vue.http.post(`${process.env.BACKEND_API_URL}api/user/`, payload)
      .then((response) => {
        commit(mTypes.ADD_USER, response.data.data);
      })
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
  delete({ commit }, payload) {
    const path = `superadmin/${payload.user.data.id}`;
    return Vue.http.delete(`${process.env.BACKEND_API_URL}api/${path}/landlords/${payload.id}`)
      .then(() => {})
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, landlord) {
    state.landlord = landlord.data;
    if (state.landlord.phone) {
      state.landlord.phoneNumber = format({ country: state.landlord.phoneCountry, phone: state.landlord.phone.toString() }, 'International_plaintext');
    } else {
      state.landlord.phoneNumber = null;
    }
    state.error = null;
  },
  [mTypes.CLEAR_STATE](state) {
    state.landlord = {};
  },
  [mTypes.DATA_STORED](state, landlord) {
    state.landlord = landlord.data;
    state.error = null;
  },
  [mTypes.DATA_ERROR](state, error) {
    state.error = error;
  },
  [mTypes.UPDATE_USER](state, user) {
    const index = state.landlord.users.findIndex(obj => obj.id === user.id);
    state.landlord.users[index] = user;
  },
  [mTypes.ADD_USER](state, user) {
    state.landlord.users.push(user);
  },
  [mTypes.REMOVE_USER](state, userId) {
    const index = state.landlord.users.findIndex(obj => obj.id === userId);
    state.landlord.users.splice(index, 1);
  },
  [mTypes.UPDATE_PRODUCT](state, payload) {
    const index = state.tenant.products.findIndex(obj => obj.id === payload.product);
    state.tenant.products[index].issued = payload.amount;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/landlords/landlord.js